import { useMutation } from "react-query";
import { axiosInstance } from "@src/utils/axios/AxiosProvider";
import useZustandStore from "@src/helpers/zustand";

export enum LoggerTypes {
  Terms = "MOB/KYC_KYC_TERMS_AND_CONDITIONS",
  IdentomatStart = "MOB/KYC_IDENTOMAT_SDK",
  IdentomatSuccess = "KYC_VERIFICATION_SUCCESS",
  Citizenship = "MOB/KYC_CITIZENSHIP",
  Address = "MOB/KYC_LEGAL_ADDRESS",
  Employment = "MOB/KYC_EMPLOYMENT_DETAILS",
  SourceOfIncome = "MOB/KYC_SOURCE_OF_INCOME",
  ExpectedMonthlyIncomes = "MOB/KYC_MONTHLY_INCOME",
  AnnualTransactions = "MOB/KYC_EXPECTED_TURNOVER",
  PurposeOfRelationship = "MOB/KYC_BUSINESS_ACTIVITY",
  PoliticallyExposedPerson = "MOB/KYC_POLITICALLY_EXPOSED_PERSON",
  OnboardingCompletedSuccessFully = 'MOB/KYC_ONBOARDING_PROCESS_COMPLETED_SUCCESSFULLY',
  // beqshia gasaketebeli
  Contact = "MOB/CONTACT",
  Otp = "MOB/OTP",
}

const apiCall = ({
  apiKey,
  eventName,
  contextId,
}: {
  apiKey: string;
  eventName: LoggerTypes;
  contextId?: string;
}) =>
  axiosInstance.post(
    "/api/kyc/add-user-event",
    {
      eventName,
      eventClass: 1,
      eventObject: eventName,
      contextID: contextId ?? "",
    },
    {
      headers: {
        "x-api-key": apiKey,
      },
    }
  );

export const useKYCAddUserLog = () => {
  const { data } = useZustandStore();
  return useMutation({
    mutationFn: (variables: { eventName: LoggerTypes }) =>
      apiCall({ apiKey: data.apiKey, contextId: data.contextId, ...variables }),
  });
};
